// extracted by mini-css-extract-plugin
module.exports = {"content":"_21620d3522--content--Q0UfF","title":"_21620d3522--title--kxHQt","subtitle":"_21620d3522--subtitle--oDHp1"};